import { ApiTokens } from '../components/ApiTokens';

export function SettingsApiTokens() {
  return <ApiTokens />;
}
